import { GameInfo } from '../views/states/Games'
import { S3URLService } from './S3URLService'

export const ArcadeMachineService = {
  getCraftAmName: (params: { romSubCategory: string; games: Array<GameInfo> }) => {
    return params.games.find((e) => e.id === params.romSubCategory)?.name ?? ''
  },
  getCraftAmAnimationUrl: (params: { romSubCategory: string }) => {
    return S3URLService.getCraftMovieURL(params.romSubCategory)
  },
}
